import App from '../App'

// home
import Home from '../page/home/home'

// shop list
import ShopList from '../page/shop-list/ShopList'

// category
import Category from '../page/category/Category'

// product list
import ProductList from '../page/product-list/ProductList'
import OnlineList from '../page/online-list/ProductList'
import newArrivals from '../page/newArrivals/ProductList'
import FlashSaleList from '../page/flashsale-list/ProductList'
import RepurchaseList from '../page/repurchase-list/ProductList'
import TopicList from '../page/topic/topic'
import PromotionList from '../page/promotion-list/promotion'
import redGoods from '../page/redGoods/ProductList'


// product detail
import ProductDetail from '../page/product-detail/ProductDetail'
import CombinationPromotionList from '../page/product-detail/CombinationPromotionList'

// cart
import Cart from '../page/cart/cart'

// ScanCart
import ScanCart from '../page/scan-cart/cart'

// product recommend & accessory
import Recommend from '../page/recommend/Recommend'
import Accessory from '../page/recommend/Accessory' 

// import Promotions from '../page/promotions/Promotions'

// search
import Search from '../page/search/search'

// auth
import Signin from '../page/auth/Signin'
import Signup from '../page/auth/Signup'
import Retrieve from '../page/auth/Retrieve'
import MobileConfirm from '../page/auth/MobileConfirm'
import EmailConfirm from '../page/auth/EmailConfirm'
import Bind from '../page/auth/Bind'
import WebPage from '../page/auth/WebPage'

// profile
import Profile from '../page/profile/Profile'
import ProfileInfo from '../page/profile/ProfileInfo'
import ProfileEdit from '../page/profile/ProfileEdit'
import ProfileAdd from '../page/profile/ProfileAdd'

import Setting from '../page/profile/Setting'
import Help from '../page/profile/Help'
import HelpUrl from '../page/profile/child/HelpUrl'
import Collection from '../page/profile/Collection'
import PaymentCode from '../page/payment-code/PaymentCode'

// article
import ArticleCat from '../page/article/ArticleCat'

// message
import MessageCenter from '../page/message/MessageCenter'
import OrderMessageList from '../page/message/OrderMessageList'
import SystemMessageList from '../page/message/SystemMessageList'

// cardpage
import CardPage from '../page/cardpage/CardPage'

// address
import AddressList from '../page/address/AddressList'
import AddressManage from '../page/address/AddressManage'
import AddressEdit from '../page/address/AddressEdit'

// virtual card
import VirtualCard from '../page/virtualCard/VirtualCard'
import VcardDetail from '../page/virtualCard/VcardDetail'
//import VCardUsable from '../page/virtualCard/VCardUsable'

// coupon
import CouponList from '../page/coupon/CouponList'
import CouponUsable from '../page/coupon/CouponUsable'

// cashgift
import CashgiftList from '../page/cashgift/CashgiftList'
import CashgiftUsable from '../page/cashgift/CashgiftUsable'

// score
import ScoreList from '../page/score/ScoreList'
import ScoreSignIn from '../page/score/ScoreSignIn'
import ScoreRule from '../page/score/child/ScoreRule'

// checkout
import Checkout from '../page/checkout/Checkout'
import GoodsList from '../page/checkout/GoodsList'
import Shipping from '../page/checkout/Shipping'
import Invoice from '../page/checkout/Invoice'




// scanCheckout
import scanCheckout from '../page/scanCheckout/Checkout'
import scanGoodsList from '../page/scanCheckout/GoodsList'
import scanShipping from '../page/scanCheckout/Shipping'
import scanInvoice from '../page/scanCheckout/Invoice'

// payment
import Payment from '../page/payment/Payment'
import PaySucceed from '../page/payment/PaySucceed'

// order
import Order from '../page/order/Order'
import OrderDetail from '../page/order/OrderDetail'
import OrderTrack from '../page/order/child/OrderTrack'
import OrderTrade from '../page/order/child/OrderTrade'
import OrderComment from '../page/order/child/OrderComment'
import OrderSubmit from '../page/order/child/OrderSubmit'


//scanOrder
import scanOrder from '../page/scanOrder/Order'
import scanOrderDetail from '../page/scanOrder/OrderDetail'
import scanOrderTrade from '../page/scanOrder/child/OrderTrade'
import scanOrderComment from '../page/scanOrder/child/OrderComment'
import scanOrderSubmit from '../page/scanOrder/child/OrderSubmit'

// Discount
import Discount from '../page/discount/Discount'
import DiscountDetail from '../page/discount/DiscountDetail'

// IntegralMall
import IntegralMall from '../page/integralmall/IntegralMall'

// bonus
import BonusList from '../page/bonus/BonusList'
import BonusRule from '../page/bonus/BonusRule'
import RecommendList from '../page/bonus/RecommendList'
import BonusQR from '../page/bonus/BonusQR'

// balance
import BalanceUsable from '../page/balance/BalanceUsable'
import BalanceHistory from '../page/balance/BalanceHistory'
import Recharge from '../page/balance/recharge'

// withdraw
import WithdrawSuccess from '../page/withdraw/WithdrawSuccess'
import WithdrawHistory from '../page/withdraw/WithdrawHistory'

export default [
	{
		path: '/',
		component: App,
		children: [
			{
				path: '',
				alias: '/home',
				name: 'home',
				component: Home,
				meta: {
					keepAlive: true,
					isshowtabbar: true
				}
			},
			{
				name: 'ShopList',
				path: '/ShopList',
				component: ShopList,
				meta: {
					isshowtabbar: true,
					keepAlive: true
				}
			},
			{
				name: 'category',
				path: '/category/:id?',
				component: Category,
				meta: {
					isshowtabbar: true,
					keepAlive: true
				}
			},
			{
				name: 'products',
				path: '/products',
				component: ProductList,
				meta: {
					keepAlive: true
				}
			},
			{
				name: 'flashSale',
				path: '/flashSale',
				component: FlashSaleList,
				meta: {
					keepAlive: true
				}
			},
			{
				name: 'repurchase',
				path: '/repurchase',
				component: RepurchaseList,
				meta: {
					keepAlive: true
				}
			},
			{
				name: 'online',
				path: '/online',
				component: OnlineList,
				meta: {
					keepAlive: true
				}
			},
			{
				name: 'newArrivals',
				path: '/newArrivals',
				component: newArrivals,
				meta: {
					keepAlive: true
				}
			},
			{
				name: 'topic',
				path: '/topic/:tid?/:display_area?',
				component: TopicList,
				meta: {
					keepAlive: false
				}
			},
			{
				name: 'promotionList',
				path: '/promotionList',
				component: PromotionList,
				meta: {
					keepAlive: true
				}
			},
			{
				name: 'redGoods',
				path: '/redGoods',
				component: redGoods,
				meta: {
					keepAlive: true
				}
			},
			{
				name: 'search',
				path: '/search',
				component: Search
			},
			{
				name: 'signin',
				path: '/signin',
				component: Signin
			},
			{
				name: 'signup',
				path: '/signup',
				component: Signup
			},
			{
				name: 'retrieve',
				path: '/retrieve',
				component: Retrieve
			},
			{
				name: 'mobileConfirm',
				path: '/mobileConfirm',
				component: MobileConfirm
			},
			{
				name: 'emailConfirm',
				path: '/emailConfirm',
				component: EmailConfirm
			},
			{
				name: 'bind',
				path: '/bind',
				component: Bind
			},
			{
				name: 'webPage',
				path: '/webPage',
				component: WebPage
			},
			{
				name: 'profile',
				path: '/profile',
				component: Profile,
				meta: {
					isshowtabbar: true
				}
			},
			{
				name: 'paymentCode',
				path: '/paymentCode',
				component: PaymentCode,
			},
			{
				name: 'setting',
				path: '/setting',
				component: Setting
			},
			{
				name: 'profileInfo',
				path: '/profileInfo',
				component: ProfileInfo
			},
			{
				name: 'profileAdd',
				path: '/profileAdd',
				component: ProfileAdd
			},
			{
				name: 'Help',
				path: '/help/:cateId?',
				component: Help
			},
			{
				name: 'HelpUrl',
				path: '/helpUrl',
				component: HelpUrl
			},
			{
				name: 'messageCenter',
				path: '/messageCenter',
				component: MessageCenter,
				meta: {
					keepAlive: false
				}
			},
			{
				name: 'ArticleCat',
				path: '/articleCat/:id?',
				component: ArticleCat
			},
			{
				name: 'orderMessageList',
				path: '/orderMessageList',
				component: OrderMessageList
			},
			{
				name: 'systemMessageList',
				path: '/systemMessageList',
				component: SystemMessageList
			},
			{
				name: 'Collection',
				path: '/collection',
				component: Collection
			},
			{
				name: 'addressList',
				path: '/addressList',
				component: AddressList
			},
			{
				name: 'addressManage',
				path: '/addressManage',
				component: AddressManage,
				meta: {
					keepAlive: false
				}
			},
			{
				name: 'addressEdit',
				path: '/addressManage/addressEdit',
				component: AddressEdit,
				meta: {
					keepAlive: false
				}
			},
			{
				name: 'virtualCard',
				path: '/virtualCard',
				component: VirtualCard
			},
			{
				name: 'vcardDetail',
				path: '/vcardDetail/:vcardDetail?',
				component: VcardDetail
			},
			{
				name: 'couponList',
				path: '/couponList',
				component: CouponList
			},
			{
				name: 'couponUsable',
				path: '/checkout/couponUsable',
				component: CouponUsable,
				meta: {
					keepAlive: true
				}
			},
			{
				name: 'cashgiftList',
				path: '/cashgiftList',
				component: CashgiftList
			},
			{
				name: 'cashgiftUsable',
				path: '/checkout/cashgiftUsable',
				component: CashgiftUsable,
				meta: {
					keepAlive: true
				}
			},
			{
				name: 'checkout',
				path: '/checkout/:isExchange?/:exchangeScore?/:isCart?',
				component: Checkout,
				meta: {
					keepAlive: false
				}
			},
			{
				name: 'scanCheckout',
				path: '/scanCheckout/:isExchange?/:exchangeScore?/:isCart?',
				component: scanCheckout,
				meta: {
					keepAlive: false
				}
			},
			{
				name: 'payment',
				path: '/payment',
				component: Payment
			},
			{
				name: 'paySucceed',
				path: '/paySucceed',
				component: PaySucceed
			},
			{
				name: 'goodsList',
				path: '/checkout/goodsList',
				component: GoodsList
			},
			{
				name: 'scanGoodsList',
				path: '/scanCheckout/goodsList',
				component: scanGoodsList
			},
			{
				name: 'shipping',
				path: '/checkout/shipping',
				component: Shipping
			},
			{
				name: 'scanShipping',
				path: '/scanCheckout/shipping',
				component: scanShipping
			},
			{
				name: 'invoice',
				path: '/checkout/invoice',
				component: Invoice
			},
			{
				name: 'scanInvoice',
				path: '/scanCheckout/invoice',
				component: scanInvoice
			},
			{
				name: 'cardpage',
				path: '/cardpage/:name',
				component: CardPage
			},
			{
				name: 'order',
				path: '/order/:order?',
				component: Order
			},
			{
				name: 'scanOrder',
				path: '/scanOrder/:order?',
				component: scanOrder
			},
			{
				name: 'orderDetail',
				path: '/orderDetail/:orderDetail?',
				component: OrderDetail
			},
			{
				name: 'scanOrderDetail',
				path: '/scanOrderDetail/:orderDetail?',
				component: scanOrderDetail
			},
			
			{
				name: 'orderTrack',
				path: '/orderTrack/:orderTrack?',
				component: OrderTrack
			},
			{
				name: 'orderTrade',
				path: '/orderTrade',
				component: OrderTrade
			},
			{
				name: 'scanOrderTrade',
				path: '/scanOrderTrade',
				component: scanOrderTrade
			},
			{
				name: 'orderComment',
				path: '/orderComment',
				component: OrderComment
			},
			{
				name: 'orderSubmit',
				path: '/orderSubmit',
				component: OrderSubmit
			},
			{
				name: 'product',
				path: '/product/:id?/:productId?',
				component: ProductDetail
			},
			{
				name: 'cart',
				path: '/cart/:type?',
				component: Cart,
				meta: {
					// isshowtabbar: true,
					setIsShowTabBar: 'type'
				}
			},
			{
				name: 'scancart',
				path: '/scancart/:type?',
				component: ScanCart,
				meta: {
					setIsShowTabBar: 'type'
				}
			},
			{
				name: 'recommend',
				path: 'recommend/:product?/:category?/:brand?/:shop?',
				component: Recommend,
				meta: {
					keepAlive: false
				}
			},
			{
				name: 'accessory',
				path: '/accessory/:product?',
				component: Accessory
			},
			{
				name: 'profileEdit',
				path: '/profileEdit/:type',
				component: ProfileEdit
			},
			{
				name: 'scoreList',
				path: '/scoreList',
				component: ScoreList
			},
			{
				name: 'scoreRule',
				path: '/scoreRule',
				component: ScoreRule
			},
			{
				name: 'scoreSignIn',
				path: '/scoreSignIn',
				component: ScoreSignIn
			},
			
			// {
			// 	name: 'promotions',
			// 	path: '/promotions',
			// 	component: Promotions
			// },
			{
				name: 'integralMall',
				path: '/integralMall',
				component: IntegralMall
			},
			{
				name: 'bonusList',
				path: '/bonusList',
				component: BonusList
			},
			{
				name: 'bonusQR',
				path: '/bonusQR',
				component: BonusQR
			},
			{
				name: 'bonusRule',
				path: '/bonusRule',
				component: BonusRule
			},
			{
				name: 'recommendList',
				path: '/recommendList',
				component: RecommendList
			},
			{
				name: 'balanceUsable',
				path: '/balanceUsable',
				component: BalanceUsable
			},
			{
				name: 'discount',
				path: '/discount',
				component: Discount,
				meta: {
					isshowtabbar: true
				}
			},
			{
				name: 'combinationPromotionList',
				path: '/combinationPromotionList',
				component: CombinationPromotionList,
				meta: {
					// isshowtabbar: true
				}
			},
			{
				name: 'discountDetail',
				path: '/discountDetail',
				component: DiscountDetail
			},
			{
				name: 'balanceHistory',
				path: '/balanceHistory',
				component: BalanceHistory
			},
			{
				name: 'recharge',
				path: '/recharge',
				component: Recharge
			},
			{
				name: 'withdrawSuccess',
				path: '/withdrawSuccess',
				component: WithdrawSuccess
			},
			{
				name: 'withdrawHistory',
				path: '/withdrawHistory',
				component: WithdrawHistory
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/router.js